import * as Panels from '../../util/panels';
import React from 'react';
import {MarkdownConfig} from './common';
import * as Query from '../../util/queryts';
import {toRunsDataQuery, RunsDataQuery} from '../../containers/RunsDataLoader';
export type {MarkdownConfig};

const PANEL_TYPE = 'Markdown Panel';

const transformQuery = (query: Query.Query): RunsDataQuery => {
  const result = toRunsDataQuery(query);
  result.disabled = true;
  return result;
};

export const Spec: Panels.PanelSpec<typeof PANEL_TYPE, MarkdownConfig> = {
  type: PANEL_TYPE,
  Component: React.lazy(() => import('./Component')),
  transformQuery,
  noEditMode: true,
  icon: 'panel-text',
};
